import { viewFromPathname } from 'react/matchmaking/unified/netplayView';

// Which part of the header a path belongs to, so the header marks it active.
// The page path comes from PHP on load and from the router (or the netplay app)
// after that.

export const HEADER_SECTIONS = Object.freeze({
	chat: 'chat',
	play: 'play',
	ranks: 'ranks',
	logIn: 'log-in',
	signUp: 'sign-up',
	subscribe: 'subscribe',
	ownProfile: 'own-profile',
});

const NETPLAY_PATH = /^\/netplay(\/|$)/i;
const RANKINGS_PATH = /^\/rankings(\/|$)/i;
const RANKINGS_LADDER_PATH = /^\/rankings\/([^/?#]+)/i;

function startsWithSegment(path, prefix) {
	const lowerPath = path.toLowerCase();
	const lowerPrefix = prefix.toLowerCase().replace(/\/+$/, '');
	return lowerPath === lowerPrefix || lowerPath.startsWith(`${lowerPrefix}/`);
}

export function sectionForPath(path, viewerProfilePath = null) {
	const pagePath = path || '/';
	if(NETPLAY_PATH.test(pagePath)) {
		return viewFromPathname(pagePath) === 'chat' ? HEADER_SECTIONS.chat : HEADER_SECTIONS.play;
	}
	if(RANKINGS_PATH.test(pagePath)) {
		return HEADER_SECTIONS.ranks;
	}
	if(startsWithSegment(pagePath, '/log-in')) {
		return HEADER_SECTIONS.logIn;
	}
	if(startsWithSegment(pagePath, '/sign-up')) {
		return HEADER_SECTIONS.signUp;
	}
	if(startsWithSegment(pagePath, '/subscribe')) {
		return HEADER_SECTIONS.subscribe;
	}
	if(viewerProfilePath && startsWithSegment(pagePath, viewerProfilePath)) {
		return HEADER_SECTIONS.ownProfile;
	}
	return null;
}

// The ladder url segment of a /rankings/<ladder>/... path, or null.
export function currentLadderUrl(path) {
	const match = RANKINGS_LADDER_PATH.exec(path || '');
	return match ? match[1] : null;
}
